module.exports = require("./naq-NA.js");